<template>
  <section id="assist__error">
    <div class="icon">
      <i class="anyteachicon anyteach-cuowu" />
    </div>
    <div class="title">{{ title }}</div>
    <div class="sub">{{ sub }}</div>
    <router-link v-if="showButton" tag="div" to="/invite" class="btn-secondary"
      >返回首页</router-link
    >
  </section>
</template>

<script>
export default {
  name: "AssistError",
  props: ["title", "sub", "showButton"],
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
#assist__error {
  text-align: center;

  i,
  .title {
    color: $purple;
  }
  i {
    font-size: 60px;
    line-height: 60px;
  }
  .icon {
    padding: 0 0 20px 0;
  }
  .title {
    @include title();
    padding: 0 0 5px 0;
  }
  .sub {
    @include secondary();
    font-size: 1rem;
  }
  .btn-secondary {
    margin-top: 40px;
  }
}
</style>
